import { Icon, IconsName } from "components/Icon"

const PaymentType: Record<string, IconsName> = {
    MasterCard: "mastercard",
    Visa: "visa",
    MIR: "mir",
    Maestro: "maestro",
    Unionpay: "unionpay",
    JCB: "jcb",
    DinersClub: "dinersclub",
    AmericanExpress: "americanexpress",
    default: "credit-card-grey",
}

interface Props {
    cardName: string | null | undefined
    className?: string
}

export function PaymentIcon({ cardName, className }: Props) {
    const cardTypeObj =
        cardName && PaymentType[cardName] ? PaymentType[cardName] : PaymentType.default

    return <Icon type={cardTypeObj} size={24} className={className} />
}
